import apiClient from '../apiClient';
import WebActivityClient from './webActivityClient';
import WebActivityController from './webActivityController';

/**
 * IMBEE-8954 — the wired singleton, mirroring `campaign/index.ts` and `apiClient/index.ts`.
 *
 * Identity getters read `apiClient`'s LIVE fields rather than snapshotting: both tokens change
 * after this module is first imported (session creation, token refresh), and every beacon must
 * carry the current value.
 */
const identity = {
  getVisitorToken: () => apiClient.visitorToken,
  getWidgetToken: () => apiClient.widgetToken,
};

const webActivityClient = new WebActivityClient(identity);
const webActivityController = new WebActivityController(webActivityClient, identity);

export default webActivityController;
